import Request from './request'
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'
import consts from "@/consts.js";

// 批次管理
async function fetch(data){
  return Request("get","api/stock-details/index",data)
}

// 批次管理
async function fetchOne(id){
  return Request("get","api/stock-details/view/" + id)
}

// 冻结
async function prohibit(id){
  return Request("post","api/stock-details/prohibit/" + id)
}
// 解冻
async function unProhibit(id){
  return Request("post","api/stock-details/un-prohibit/" + id)
}
// 报损
async function loss(id){
  return Request("post","api/stock-details/loss/" + id)
}

async function exports(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-details/export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

// 获取批次退货商品信息
async function getReturnList(data){
  if (!data) data = {}
  data.limit = consts.limitAll; // 获取全部
  data.itemsPerPage = consts.limitAll // 获取全部
  return Request("get","api/stock-details/return-list", data)
}

export default {
  fetch,
  fetchOne,
  prohibit,
  unProhibit,
  loss,
  exports,
  getReturnList,
}